import React from 'react';
import Icon from "../../../basic/Icon/Icon.js";
var ToastIcon = _ref => {
  var {
    component
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    component: component,
    size: "medium"
  });
};
export default ToastIcon;